var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dj-form",style:({
             '--width':_vm.width
           })},[_c('el-form',{ref:_vm.formIdentifier,staticClass:"dj-form__wrap",staticStyle:{"width":"100%"},attrs:{"rules":_vm.rules,"size":_vm.size,"label-position":_vm.labelPosition,"model":_vm.model,"label-width":_vm.labelWidth},on:{"validate":_vm.validateFormCell}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }